import { render, staticRenderFns } from "./UnSavedChanges.vue?vue&type=template&id=2c6b0c47&"
import script from "./UnSavedChanges.vue?vue&type=script&lang=ts&"
export * from "./UnSavedChanges.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports